import React from 'react';
import { css } from 'emotion';
import RawHtml from '../RawHtml';
import * as cs from './style';

export const InformationText = ({ children }) => {
  return (
    <div className={css`${cs.informationText}`}>
      <i className="icon-max-communication-info" />
      <RawHtml>
        {children}
      </RawHtml>
    </div>
  )
};

export default InformationText;